type ActingUser =
  | { email?: unknown; isCooperateUser?: unknown }
  | null
  | undefined;

// The creator is emailed the onboarding summary; blank or whitespace counts as missing.
export const hasEmail = (user: ActingUser) =>
  typeof user?.email === "string" && user.email.trim().length > 0;

// Profile only unlocks the email field for corporate users, so only they can fix it themselves.
export const canEditOwnEmail = (user: ActingUser) =>
  Boolean(user?.isCooperateUser);

export const blockedAddUserMessage = (user: ActingUser) =>
  canEditOwnEmail(user)
    ? "Add an email address to your profile before adding new users."
    : "Your account has no email address. Ask your administrator to add one before you can add new users.";
